import React from 'react';
import { ZoomMeta } from '../../hooks/useZoomPreview';

interface DashboardImagePreviewProps {
  imageUrl?: string | null;
  fallback: string;
  size: number;
  alt?: string;
  title?: string;
  className?: string;
  isReviewed?: boolean;
  meta?: ZoomMeta;
  onImageHover?: (event: React.MouseEvent, url: string, meta?: ZoomMeta) => void;
  onImageMove?: (event: React.MouseEvent, url: string, meta?: ZoomMeta) => void;
  onImageLeave?: () => void;
}

export const DashboardImagePreview: React.FC<DashboardImagePreviewProps> = ({
  imageUrl,
  fallback,
  size,
  alt = '',
  title,
  className,
  isReviewed,
  meta,
  onImageHover,
  onImageMove,
  onImageLeave,
}) => {
  const reviewClass =
    isReviewed === undefined ? undefined : isReviewed ? 'is-reviewed' : 'is-unreviewed';
  const classes = ['forge-dashboard-thumb', className, reviewClass].filter(Boolean).join(' ');
  const style = { width: size, height: size } as React.CSSProperties;

  return (
    <div
      role="group"
      className={classes}
      title={title}
      aria-label={
        isReviewed === undefined
          ? undefined
          : isReviewed
            ? 'Reviewed Design'
            : 'Design needs review'
      }
      style={style}
      onMouseEnter={
        imageUrl && onImageHover ? (event) => onImageHover(event, imageUrl, meta) : undefined
      }
      onMouseMove={
        imageUrl && onImageMove ? (event) => onImageMove(event, imageUrl, meta) : undefined
      }
      onMouseLeave={imageUrl ? onImageLeave : undefined}
    >
      {imageUrl ? <img src={imageUrl} alt={alt} loading="lazy" /> : <span>{fallback}</span>}
    </div>
  );
};
